module.exports = {
   version : { 
       name: 5.0,
       features: [ "UI/UX Redesign", "New UI", "Optimized search", "Bug Fixes"],
   }

   //todo: Update the versioning to allow version rollback or resets.
    // Since this is client side.  I have the power.
}